import { TemplateService } from "@adfenix/types";
import { useNavigate } from "react-router-dom";
import { StyledTemplateAction } from "./TemplateList";

interface Props {
  template:
    | TemplateService.FacebookContentTemplateModel
    | TemplateService.InstagramContentTemplateModel
    | TemplateService.TwitterContentTemplateModel
    | TemplateService.ImageTemplateModel;
  channel?: TemplateService.ChannelType;
  onPreview: (id: string) => void;
}

export function TemplateActions({ template, channel, onPreview }: Props) {
  const navigate = useNavigate();

  return (
    <>
      <StyledTemplateAction
        logLabel="preview-template-button"
        variant="secondary"
        onClick={() => onPreview(template.id!)}
        id={`preview-button-${template.id}`}
      >
        <i className={"uil uil-eye"} />
      </StyledTemplateAction>

      <StyledTemplateAction
        logLabel="edit-template-button"
        variant="secondary"
        onClick={() =>
          isImageTemplate(template)
            ? navigate(`./edit/${template.id}`)
            : channel &&
              navigate(`./edit/${channel.toLowerCase()}/${template.id}`)
        }
      >
        <i className={"uil uil-pen"} />
      </StyledTemplateAction>

      <StyledTemplateAction
        logLabel="delete-template-button"
        variant="secondary"
        onClick={() => {
          isImageTemplate(template)
            ? navigate(`./delete/${template.id}`)
            : channel &&
              navigate(`./delete/${channel.toLowerCase()}/${template.id}`);
        }}
      >
        <i className={"uil uil-trash-alt"} />
      </StyledTemplateAction>
    </>
  );
}

const isImageTemplate = (
  template:
    | TemplateService.ImageTemplateModel
    | TemplateService.FacebookContentTemplateModel
    | TemplateService.InstagramContentTemplateModel
    | TemplateService.TwitterContentTemplateModel
): template is TemplateService.ImageTemplateModel => {
  return template.hasOwnProperty("templateUrl");
};
